import { useQuery, UseQueryResult } from 'react-query';
import { BASS_API_URL } from '@/src/constants/endpoints';
import { BeyondAccountStatusGraphqlResponse } from '@/src/types/Response';
import { apiService } from '@/src/services/api-service';
import { useAccountContext } from '@ovotech/ui-tools';

const query = `
  query BeyondAccountStatus($accountId: String!) {
      beyondAccountStatus(accountId: $accountId) {
          status
          directDebitStatus
          smartMeterStatus
      }
  }
`;

const graphqlBody = ({ accountId }: { accountId: string }) => {
  return {
    query,
    operationName: 'BeyondAccountStatus',
    variables: { accountId },
  };
};

export const beyondAccountStatusQueryKey = (accountId: string) => [
  `beyond-account-status-graphql-${accountId}`,
];

export const beyondAccountStatusQueryFn = (accountId: string) =>
  apiService.graphql<BeyondAccountStatusGraphqlResponse>({
    url: BASS_API_URL,
    body: graphqlBody({ accountId }),
  });

export const useBeyondAccountStatusQuery =
  (): UseQueryResult<BeyondAccountStatusGraphqlResponse> => {
    const { accountId } = useAccountContext();

    return useQuery(
      beyondAccountStatusQueryKey(accountId ?? ''),
      () => beyondAccountStatusQueryFn(accountId ?? ''),
      {
        enabled: !!accountId,
      },
    );
  };
